setTimeout(function(){
 const buyButton = document.querySelectorAll('.shopify-payment-button__button');
buyButton.forEach(button => {
  button.textContent = "Buy Now";
});
    
},1000);
document.querySelectorAll('div[data-shopify="payment-button"]').forEach(el => {
    el.style.setProperty('display', 'block', 'important');
});






document.addEventListener("variant:changed", function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const oldPrice = document.querySelector(".product-price-new-raj .old-price");
  const newPrice = document.querySelector(".product-price-new-raj .new-price");
  const perPrice = document.querySelector(".product-price-new-raj .per-price");

  if (variant.compare_at_price > variant.price) {
    oldPrice.innerHTML = `<s>${Shopify.formatMoney(variant.compare_at_price)}</s>`;
    newPrice.innerHTML = Shopify.formatMoney(variant.price);

    const discount =
      ((variant.compare_at_price - variant.price) * 100) /
      variant.compare_at_price;

    perPrice.innerHTML = `${Math.round(discount)}% OFF`;
  } else {
    oldPrice.innerHTML = "";
    newPrice.innerHTML = Shopify.formatMoney(variant.price);
    perPrice.innerHTML = "";
  }
});

